var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7a1 1 0 000 2h10a1 1 0 100-2H7zM9 12a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zM9 16a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgN0M2LjQ0NzcyIDcgNiA3LjQ0NzcyIDYgOEM2IDguNTUyMjggNi40NDc3MiA5IDcgOUgxN0MxNy41NTIzIDkgMTggOC41NTIyOCAxOCA4QzE4IDcuNDQ3NzIgMTcuNTUyMyA3IDE3IDdIN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNOSAxMkM5IDExLjQ0NzcgOS40NDc3MiAxMSAxMCAxMUgxN0MxNy41NTIzIDExIDE4IDExLjQ0NzcgMTggMTJDMTggMTIuNTUyMyAxNy41NTIzIDEzIDE3IDEzSDEwQzkuNDQ3NzIgMTMgOSAxMi41NTIzIDkgMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTkgMTZDOSAxNS40NDc3IDkuNDQ3NzIgMTUgMTAgMTVIMTdDMTcuNTUyMyAxNSAxOCAxNS40NDc3IDE4IDE2QzE4IDE2LjU1MjMgMTcuNTUyMyAxNyAxNyAxN0gxMEM5LjQ0NzcyIDE3IDkgMTYuNTUyMyA5IDE2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };